import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import * as React from "react";

import { Paper, Tabs, Typography, Breadcrumbs } from "mpulse-design-system";
import { Link } from "react-router-dom";
import { Box, Grid, Tab, styled } from "@mui/material";

import { AudioContextProvider } from "../../hooks/useAudio";
import { pluralize } from "../../utils/utils";

import DataTable from "../../components/DataTable/DataTable";
import MetadataTable from "../../components/MetadataTable/MetadataTable";
import { useEffect } from "react";
import { API_V1_GET_AUDIO_FILE_INFO_REQUEST } from "../../redux/audioFile/actionTypes";

const Account = () => {
  const dispatch = useDispatch();
  const { accountId } = useParams();
  const { accountsMap } = useSelector((state) => state["client"]);
  const { client, accounts, metadata } = useSelector((state) => state);
  const audioLoading = useSelector((state) => state.audioFile.loading);

  const accountIds = Object.keys(client.accountsMap);

  const account = useSelector(({ accounts }) => {
    const accountIndex = accountsMap[accountId];
    if (accounts && accountIndex >= 0) return accounts[accountIndex];
    else return undefined;
  });
  const audioReadyForReview = useSelector(({ audioFile }) => {
    return audioFile[accountId].status.readyForReview.audio;
  });
  const [selectedTab, setSelectedTab] = React.useState(
    parseInt(sessionStorage.getItem("aoede:selectedTab")) || 0
  );

  const handleChange = (e, newSelectedTab) => {
    sessionStorage.setItem("aoede:selectedTab", newSelectedTab);
    setSelectedTab(newSelectedTab);
  };

  useEffect(() => {
    if (selectedTab === 0) {
      dispatch({
        type: API_V1_GET_AUDIO_FILE_INFO_REQUEST,
        accountIds: accountIds,
      });
    }
  }, [selectedTab]);

  const getColumnProps = (title, size) => {
    return { title, size };
  };

  return (
    <AudioContextProvider>
      <Box
        sx={{
          margin: (theme) => theme.spacing(3),
          paddingLeft: "16px",
          paddingRight: "16px",
        }}
      >
        <Grid container spacing={6}>
          <Grid item xxs={12}>
            <Breadcrumbs>
              <StyledLink to="/dashboard">
                <Typography color="textTertiary" variant="overline">
                  DASHBOARD HOME
                </Typography>
              </StyledLink>
              <Typography color="textPrimary" variant="overline">
                REGION OVERVIEW
              </Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item container spacing={3}>
            <Grid item xxs={12}>
              <Typography color="textPrimary" variant="h1">
                {account.name}
              </Typography>
            </Grid>
            <Grid item container spacing={0}>
              <Grid item xxs={12}>
                <Paper
                  variant="elevation"
                  elevation={0}
                  square
                  sx={{
                    padding: (theme) =>
                      `${theme.spacing(2)} ${theme.spacing(3)}`,
                    backgroundColor: "white",
                  }}
                >
                  <Tabs
                    value={selectedTab}
                    onChange={handleChange}
                    textColor="primary"
                    aria-label="Account tab selector"
                  >
                    <Tab label="AUDIO READY FOR REVIEW" id="audio-ready-tab" />
                    <Tab
                      label={pluralize(account.metadataLabel, {
                        pluralizeAnyway: true,
                        returnCount: false,
                      })}
                      id="metadata-tab"
                    />
                  </Tabs>
                </Paper>
              </Grid>
              <Grid item xxs={12}>
                {/* TODO: Column names are hard coded at the moment. Will need to refactor when other clients use this tool*/}
                <DataTable
                  loading={audioLoading}
                  type="AUDIO"
                  value={selectedTab}
                  index={0}
                  columnsMap={{
                    date: getColumnProps("Date Added", "10%"),
                    client_department_id: getColumnProps("Dept. ID", "10%"),
                    metadata_name: getColumnProps(
                      "Dept. Name/Dept. Friendly Name",
                      "13%"
                    ),
                    content: getColumnProps("Content", "17%"),
                    type: getColumnProps("File Type", "11%"),
                    language: getColumnProps("Language", "10%"),
                    audioPlayer: getColumnProps("Audio Player", "10%"),
                    status: getColumnProps("Status", "18%"),
                  }}
                  data={audioReadyForReview}
                  metadataLabel={account.metadataLabel}
                  accountId={accountId}
                />
                <MetadataTable
                  type="METADATA"
                  value={selectedTab}
                  index={1}
                  account={account}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </AudioContextProvider>
  );
};

const StyledLink = styled(Link)(({ theme }) => ({
  position: "relative",
  padding: `${theme.spacing(1)}`,
  color: "inherit",
  textDecoration: "none",
}));

export default Account;
